import VConsole from "vconsole";

const LoginData = {
  ctx: null,
  init(ctx) {
    this.ctx = ctx;
  },
  SuccessCallBack: null,

  tokenLogin() {
    let info = this.ctx.$info
    let http = this.ctx.$http_data
    let self = this

    if (info.id.length > 0 && info.soaToken.length > 0) {//免密登录
      http.loginToken(info.id, info.soaToken, function (data) {
        self.onLoginSuccess(data)
      }, function () {
        self.lastLogin()
      })
    } else {
      self.lastLogin()
    }

    this.config_wxin()
  },

  lastLogin() {
    let store = this.ctx.$store
    let info = this.ctx.$info
    let http = this.ctx.$http_data
    let preference = this.ctx.$preference

    let self = this
    let lastLoginType = preference.getLastLoginType()

    if (info.isPhoneAccount()) {
      let phone = preference.getPhoneAccount();
      let pwd = preference.getPhonePwd()
      if (phone.length > 0 && pwd.length > 0) {
        http.loginPhone(phone, pwd, function (data) {
          self.onLoginSuccess(data)
        }, function (err) {
          self.naveToLogin()
        })
      } else {
        self.naveToLogin()
      }
    } else if (info.isWxinBrowserAccount()) {
      self.naveToLogin()
    } else if (info.isGuestAccount()) {
      http.loginGuest(function (data) {
        self.onLoginSuccess(data)
      }, function (err) {
        self.naveToLogin()
      })
    } else {
      http.loginGuest(function (data) {
        preference.saveLastLoginType('guest')
        self.onLoginSuccess(data)
      }, function (err) {
        self.naveToLogin()
      })
    }
  },

  naveToLogin() {
    this.ctx.$nav_util.naveToLogin()
  },

  //登录成功回调
  onLoginSuccess(data) {
    let self = this
    let info = this.ctx.$info
    this.ctx.$store.state.logined = true

    let id = info.id;
    let token = info.soaToken;
    info.logout()
    info.id = id;
    info.soaToken = token;
    this.ctx.$logger.log(' onLoginSuccess-s ', JSON.stringify(data))
    info.parse(this.ctx, data)
    this.ctx.$logger.log(' onLoginSuccess-l ' + JSON.stringify(this.ctx.$info))

    this.ctx.$http_data.infoGet(function (data) {
      info.parse(self.ctx, data)
      self.ctx.$info.loginOK = true
      if (self.SuccessCallBack) {
        self.SuccessCallBack.call()
      }
      if (!info.isGuestAccount()) {
        self.ctx.$socket.connect()
        self.ctx.$http_data.sign();
      }
      if (info.isPhoneAccount()) {
        self.ctx.$info.phone = self.ctx.$preference.getPhoneAccount()
      }
    });
    this.ctx.$websql.onLoginOK()
  },


  config_wxin() {
    // if (this.ctx.$preference.getPhoneAccount() == '17674035560') {
    //   new VConsole()
    // }

    if (isWeiXinBrowser()) {
      let self = this
      this.ctx.$http_data.wechat_ticket_get({url: encodeURI(location.href.split('#')[0])}, function (data) {
        InitWxin(data)
      }, function (data) {
        self.re_config_wxin()
      })
    }
  },

  re_config_wxin() {
    this.ctx.$http_data.wechat_ticket_get({url: encodeURI(location.href.split('#')[0])}, function (data) {
      InitWxin(data)
    })
  }
};

LoginData.install = function (Vue, options) {
  Vue.prototype.$login_data = LoginData
};

export default LoginData



// WEBPACK FOOTER //
// ./src/plugins/login-data.js